<template>
  <v-card>
    <v-card-text v-if="contact.role || languages(contact._id).length">
      <span
        class="ml-1"
        v-if="contact.role"
      >{{ contact.role }}</span>
      <span
        class="grey--text"
        v-if="languages(contact._id).length"
      >({{ languagesList(languages(contact._id)) }})</span>
    </v-card-text>
    <!-- <v-divider inset v-if="contact.description"></v-divider> -->
    <v-card-text v-if="contact.description">
      <p>{{ contact.description || 'ללא תיאור' }}</p>
    </v-card-text>
  <v-card-text v-if="contact.phone">
      <p>{{ contact.phone || 'ללא תיאור' }}</p>
    </v-card-text>
    <v-card-actions v-if="shouldShow(roles, user)">
      <v-btn
        flat
        @click="createContactDetail(contact)"
      >
        <v-icon>add</v-icon> הוספת פרט קשר
      </v-btn>
      <v-btn
        flat
        @click="edit(contact)"
      >עריכה</v-btn>
      <v-btn
        flat
        @click="remove(contact)"
        :loading="removing[contact._id]"
      >מחיקה</v-btn>
    </v-card-actions>

    <contact-details-list
      :contact-details-data="contactDetails(contact._id)"
      :parent-resource="parentResource"
      :parent-id="parentId"
      :roles="roles"
    />
  </v-card>
</template>

<script>
import ContactDetailsList from "./ContactDetailsList.vue";
import generateId from "@/idGenerator";
import shouldShow from "@/utils/shouldShow";

export default {
  data: () => {
    return {
      removing: []
    };
  },

  computed: {
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    user() {
      return this.$store.getters["user/user"];
    }
  },

  methods: {
    shouldShow,
    contactDetails(contactId) {
      return this.$store.getters["partners/contactContactDetails"](contactId);
    },
    languages(contactId) {
      return this.$store.getters["partners/contactLanguages"](contactId);
    },
    languagesList(array) {
      if (array.length) {
        return array
          .map(item => {
            return item.title;
          })
          .reduce(
            (accumulator, currentValue) => accumulator + ", " + currentValue
          );
      } else {
        return "";
      }
    },
    edit(entity, isNew = false) {
      let resource = this.resource || this.$store.state.resources.contact;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    },
    remove(contact) {
      this.$confirm("האם למחוק את איש הקשר?").then(res => {
        if (!res) {
          return;
        }

        this.$set(this.removing, contact._id, true);
        this.$store
          .dispatch("REMOVE_ENTITY", {
            url: "/contacts",
            entityType: "contacts",
            id: contact._id
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: "הפריט נמחק",
              color: "success"
            });
          })
          .catch(err => {
            console.log(err.stack);
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.$set(this.removing, contact._id, false);
          });
      });
    },
    createContactDetail(contact) {
      let newEntity = { _id: generateId(), contact: contact._id };
      this.editContactDetail(newEntity, true);
    },
    editContactDetail(entity, isNew = false) {
      let resource = this.$store.state.resources.contactDetail;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    }
  },

  props: ["contact", "resource", "parentResource", "parentId", "roles"],

  components: {
    ContactDetailsList
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue